// src/utils/profileHelpers.js

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};


export const formatDateTimeLong = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dayName = dayNames[date.getDay()];
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // 12-hour format

  return `${dayName}, ${month} ${day}, ${year}, ${hours}:${minutes} ${ampm}`;
};


export const getImageUrl = (imageUrl, IMG_BASE_URL) => {
  if (!imageUrl) return 'assets/images/thumbs/default-material.png';
  if (imageUrl.startsWith('http')) return imageUrl;
  if (imageUrl.startsWith('/')) return `${IMG_BASE_URL}${imageUrl}`;
  return `${IMG_BASE_URL}${imageUrl}`;
};

export const getStatusStyle = (status) => {
  const styles = {
    'Delivered': { class: 'delivered', icon: 'ph-check-circle', color: '#10b981' },
    'Shipped': { class: 'shipped', icon: 'ph-truck', color: '#3b82f6' },
    'Processing': { class: 'processing', icon: 'ph-clock', color: '#f59e0b' },
    'Confirmed': { class: 'confirmed', icon: 'ph-check', color: '#8b5cf6' },
    'Loading': { class: 'loading', icon: 'ph-package', color: '#6366f1' },
    'Pending': { class: 'pending', icon: 'ph-hourglass', color: '#f97316' },
    'Cancelled': { class: 'cancelled', icon: 'ph-x-circle', color: '#ef4444' }
  };
  return styles[status] || styles['Pending'];
};

export const canadianProvinces = [
  { value: '', label: 'Select Province' },
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' }
];

export const statusSteps = [
  { key: 'created_at', label: 'Order Placed', icon: 'ph-check-circle', color: 'green' },
  { key: 'processing_at', label: 'Processing Started', icon: 'ph-clock', color: 'blue' },
  { key: 'payment_date', label: 'Payment Received', icon: 'ph-currency-dollar', color: 'teal' },
  { key: 'confirmed_at', label: 'Order Confirmed', icon: 'ph-user-check', color: 'purple' },
  { key: 'dispatched_at', label: 'Dispatched', icon: 'ph-package', color: 'orange' },
  { key: 'shipped_date', label: 'Shipped', icon: 'ph-truck', color: 'cyan' },
  { key: 'out_for_delivery_at', label: 'Out for Delivery', icon: 'ph-path', color: 'amber' },
  { key: 'delivered_date', label: 'Delivered', icon: 'ph-check-circle', color: 'green' },
  { key: 'cancelled_at', label: 'Cancelled', icon: 'ph-x-circle', color: 'red' }
];
export const getStatusBgColor = (status) => {
  const bgColors = {
    'Delivered': '#d1f0d1',
    'Shipped': '#dbeafe',
    'Processing': '#fef3c7',
    'Confirmed': '#f3e8ff',
    'Loading': '#e0e7ff',
    'Pending': '#fed7aa',
    'Cancelled': '#fee2e2'
  };
  return bgColors[status] || '#f5f5f5';
};
